import { createSelector } from 'reselect';
import { selectQueryParams } from './QuerySelector';
import { selectFeatureFlags } from './ContextSelector';
import { CSE_CID, PLA_REC_PAGE_TYPE, PRODUCT } from '../common/Constants';

const selectRecPageType = createSelector(
    [selectQueryParams, selectFeatureFlags],
    (query, featureFlags) => {
        if (Object.keys(query).length) {
            if (featureFlags.plaRecommendation) {
                const { utmSource } = query;
                const kwid = query.kwid || '';
                const getPLA = kwid ? kwid.split('-').indexOf('adType^PLA') : null;
                if (featureFlags.enablePLARecommendationByCID) {
                    const cidCSE =
                        featureFlags.enablePLARecommendationByCID &&
                        query.cid &&
                        query.cid.startsWith(CSE_CID);
                    return cidCSE ? PLA_REC_PAGE_TYPE : PRODUCT;
                }
                if (utmSource === 'criteo' || (getPLA && getPLA !== -1)) {
                    return PLA_REC_PAGE_TYPE;
                }
                return PRODUCT;
            }
            return PRODUCT;
        }
        return PRODUCT;
    }
);

export default selectRecPageType;
